import { mapFields } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";
//import CommonMixin from "@/mixins/common";
export default {
  // mixins: [CommonMixin],
  methods: {
    getOperationName(operation, lang){
      let name = operation.text && operation.text[lang];
      if(name) return name;
      if(lang==='en') return operation.name_en;
      if(lang==='ru') return operation.name_ru;
      if(operation.title) return operation.title;
      return "Unknown operation";
    },
    async createCustomerAndCarForBid(bid) {
      return await this.$store
        .dispatch("bids/createCustomerAndCar", bid)
        .then(() => {
          this.$store.dispatch("bids/getList");
        });
    },
    async handleClickOrderForBid(bid) {
      if (bid.order && bid.order.id) {
        this.orderWindow.isVisible = true;
        this.orderWindow.orderId = bid.order.id;
        return;
      }

      if (parseInt(bid.customer_car_id) > 0) {
        this.goToSearchWithCustomerCar(bid.car, null, bid.id);
        return;
      }
      if (parseInt(bid.customer_id) > 0) {
        this.goToSearchWithCustomer(bid.customer, bid.id);
        return;
      }
      return await this.$confirm({
        title: this.$t("common.confirm"),
        text: this.$t("viewBids.confirm_create_customer"),
        cancelText: this.$t("common.no"),
        acceptText: this.$t("common.yes"),
      }).then(async (y) => {
        this.createCustomerAndCarForBid(bid);
      });
    },
  },
  computed: {
    ...mapFields("common", ["brands", "widgetHash"]),
    ...mapFields("site", ["first_day_of_week", "lang"]),
    ...mapFields("helptour", ["helpsteps"]),
  },
};
